/* eslint-disable */
import { getLocale, trackMessageCall, experimentalMiddlewareLocaleSplitting, isServer, experimentalStaticLocale } from '../runtime.js';
/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

const en_rn_breadcrumb_home = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Home`)
};

const es_rn_breadcrumb_home = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Inicio`)
};

const de_rn_breadcrumb_home = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Startseite`)
};

const nl_rn_breadcrumb_home = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Start`)
};

const fr_rn_breadcrumb_home = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Accueil`)
};

const it_rn_breadcrumb_home = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Home`)
};

const pt_br2_rn_breadcrumb_home = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Início`)
};

const pt_rn_breadcrumb_home = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Início`)
};

const ja_rn_breadcrumb_home = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`ホーム`)
};

const zh_rn_breadcrumb_home = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`首页`)
};

/**
* This function has been compiled by [Paraglide JS](https://inlang.com/m/gerre34r).
*
* - Changing this function will be over-written by the next build.
*
* - If you want to change the translations, you can either edit the source files e.g. `en.json`, or
* use another inlang app like [Fink](https://inlang.com/m/tdozzpar) or the [VSCode extension Sherlock](https://inlang.com/m/r7kp499g).
* 
* @param {{}} inputs
* @param {{ locale?: "en" | "es" | "de" | "nl" | "fr" | "it" | "pt-BR" | "pt" | "ja" | "zh" }} options
* @returns {LocalizedString}
*/
/* @__NO_SIDE_EFFECTS__ */
export const rn_breadcrumb_home = (inputs = {}, options = {}) => {
	if (experimentalMiddlewareLocaleSplitting && isServer === false) {
		return /** @type {any} */ (globalThis).__paraglide_ssr.rn_breadcrumb_home(inputs) 
	}
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	trackMessageCall("rn_breadcrumb_home", locale)
	if (locale === "en") return en_rn_breadcrumb_home(inputs)
	if (locale === "es") return es_rn_breadcrumb_home(inputs)
	if (locale === "de") return de_rn_breadcrumb_home(inputs)
	if (locale === "nl") return nl_rn_breadcrumb_home(inputs)
	if (locale === "fr") return fr_rn_breadcrumb_home(inputs)
	if (locale === "it") return it_rn_breadcrumb_home(inputs)
	if (locale === "pt-BR") return pt_br2_rn_breadcrumb_home(inputs)
	if (locale === "pt") return pt_rn_breadcrumb_home(inputs)
	if (locale === "ja") return ja_rn_breadcrumb_home(inputs)
	return zh_rn_breadcrumb_home(inputs)
};